export enum VerificationChoice {
  VIDEO = 0,
  DIIA,
}
